export default "__VITE_ASSET__B5AIMu23__"